import { render, staticRenderFns } from "./OrderFabricPrintTypeTable.vue?vue&type=template&id=1e827ac2&scoped=true&"
import script from "./OrderFabricPrintTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricPrintTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e827ac2",
  null
  
)

export default component.exports